<template>
  <li id="view-settings" :class="{ current: active }">
    <a href="/settings/"><i class="fa fa-cogs"></i> Einstellungen</a>
    <div class="grid-container6">
      <div class="grid-column grid-column3">
        <ul>
          <li>
            <router-link
              :to="{
                name: 'OperatorGeneralSettings',
                params: { id: 'default' }
              }"
            >
              <i class="fa fa-home"></i>
              {{ $label("operator.operator") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{
                name: 'FacilityGeneralSettings',
                params: { id: 'default' }
              }"
            >
              <i class="fa fa-dot-circle-o"></i>
              {{ $label("facility.facility") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Events' }"
              ><i class="fa fa-list-alt"></i
              >{{ $label("event.events") }}</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'InventoryProducts' }"
              ><i class="fa fa-cubes"></i
              >{{ $label("inventory.inventory") }}</router-link
            >
          </li>
          <li>
            <router-link
              :to="{ name: 'VenueGeneralSettings', params: { id: 'default' } }"
              ><i class="fa fa-list-alt"></i
              >{{ $label("venues.venues") }}</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'GroupsOverview' }"
              ><i class="fa fa-group"></i
              >{{ $label("groups.groups") }}</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'OrganizationsOverview' }"
              ><i class="fa fa-group"></i
              >{{ $label("organizations.organizations") }}</router-link
            >
          </li>
          <li>
            <a href="#"
              ><i class="fa fa-maxcdn"></i>{{ $label("groups.memberships") }}</a
            >
          </li>
          <!-- <li class="form-disabled"><a><i class="fa fa-cog"></i> Disabled entry</a></li> -->
        </ul>
      </div>
      <div class="grid-column grid-column3">
        <ul>
          <li>
            <router-link :to="{ name: 'UsersOverview' }"
              ><i class="fa fa-male"></i
              >{{ $label("staff.staff") }}</router-link
            >
          </li>
          <li>
            <a href="#"
              ><i class="fa fa-exclamation"></i>{{ $label("venuzle-info") }}</a
            >
          </li>
          <!-- <li class="form-disabled"><a><i class="fa fa-user"></i>Disabled right</a></li> -->
          <li><a>&nbsp;</a></li>
          <li><a>&nbsp;</a></li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>
